/* ============================================================
   Compre 3 Leve 4 — vitrine da página de coleção
   (sections/compre-3-leve-4.liquid)

   - Cada card monta, a partir do JSON embutido, os seletores de cor
     (bolinhas) e das demais opções (tamanho, modelo) em botões.
   - Trocar a cor troca a foto do card e atualiza os tamanhos disponíveis.
   - O botão do card adiciona a variante escolhida via /cart/add.js e
     atualiza ícone + cart drawer SEM abrir o drawer: o cliente continua
     escolhendo as próximas peças.
   - Galeria deslizável por card; chips filtram e o select ordena no cliente.
   Estratégia de update do carrinho portada de assets/dp-quick-buy.js.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-c4]');
  if (!root) return;

  function brl(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  var PIX = parseFloat(root.getAttribute('data-c4-pix')) || 0;
  var PARCELAS = parseInt(root.getAttribute('data-c4-parcelas'), 10) || 1;
  var COLOR_RE = /^cor$|^color$/i;
  var SIZE_RE = /tamanho|size/i;

  /* ---------- contagem, filtro e ordenação ---------- */
  var grid = root.querySelector('[data-c4-grid]');
  var elCount = root.querySelector('[data-c4-count]');
  function items() { return [].slice.call(grid.querySelectorAll('[data-c4-cat]')); }
  function updateCount() {
    var n = items().filter(function (li) { return !li.hidden; }).length;
    if (elCount) elCount.textContent = n + (n === 1 ? ' produto' : ' produtos');
  }
  var chips = root.querySelectorAll('[data-c4-filter]');
  [].forEach.call(chips, function (chip) {
    chip.addEventListener('click', function () {
      var f = chip.getAttribute('data-c4-filter');
      [].forEach.call(chips, function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      items().forEach(function (li) { li.hidden = !!f && li.getAttribute('data-c4-cat') !== f; });
      updateCount();
    });
  });
  var sortSel = root.querySelector('[data-c4-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var mode = sortSel.value;
    var key = mode ? 'data-c4-price' : 'data-c4-order';
    var dir = mode === 'desc' ? -1 : 1;
    items().sort(function (a, b) {
      return dir * (parseInt(a.getAttribute(key), 10) - parseInt(b.getAttribute(key), 10));
    }).forEach(function (li) { grid.appendChild(li); });
  });
  updateCount();

  /* ---------- galeria do card (scroll-snap) ---------- */
  function syncDots(gal) {
    var i = Math.round(gal.scrollLeft / Math.max(gal.clientWidth, 1));
    var dots = gal.parentNode.querySelectorAll('.c4-card__dots span');
    [].forEach.call(dots, function (d, j) { d.classList.toggle('is-on', j === i); });
  }
  [].forEach.call(root.querySelectorAll('[data-c4-gallery]'), function (gal) {
    var t;
    gal.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { syncDots(gal); }, 60); }, { passive: true });
  });

  /* ---------- estado por card ---------- */
  function Card(el) {
    var dataEl = el.querySelector('[data-c4-product]');
    this.el = el;
    this.p = JSON.parse(dataEl.textContent);
    this.opts = el.querySelector('[data-c4-opts]');
    this.msg = el.querySelector('[data-c4-msg]');
    this.btn = el.querySelector('[data-c4-card-add]');
    this.btnLabel = this.btn.textContent;
    this.priceEl = el.querySelector('[data-c4-price-el]');
    this.gallery = el.querySelector('[data-c4-gallery]');
    this.firstImg = this.gallery && this.gallery.querySelector('img');
    var names = this.p.options || [];
    this.colorIdx = names.findIndex(function (n) { return COLOR_RE.test(n); });
    this.sizeIdx = names.findIndex(function (n) { return SIZE_RE.test(n); });
    // Pré-seleciona a 1ª variante disponível, MENOS o tamanho: o cliente escolhe.
    var first = this.p.variants.find(function (v) { return v.available; }) || this.p.variants[0];
    this.sel = first ? first.options.slice() : [];
    if (this.sizeIdx >= 0 && this.values(this.sizeIdx).length > 1) this.sel[this.sizeIdx] = null;
    this.render();
  }
  Card.prototype.values = function (i) {
    var seen = {}, out = [];
    this.p.variants.forEach(function (v) {
      var val = v.options[i];
      if (!(val in seen)) { seen[val] = true; out.push(val); }
    });
    return out;
  };
  // Um valor tem estoque se existe variante disponível com ele + as OUTRAS opções escolhidas.
  Card.prototype.available = function (i, val) {
    var sel = this.sel;
    return this.p.variants.some(function (v) {
      if (!v.available || v.options[i] !== val) return false;
      return sel.every(function (s, j) { return j === i || s == null || v.options[j] === s; });
    });
  };
  Card.prototype.variant = function () {
    var sel = this.sel;
    if (sel.some(function (s) { return s == null; })) return null;
    return this.p.variants.find(function (v) {
      return sel.every(function (s, j) { return v.options[j] === s; });
    }) || null;
  };
  Card.prototype.render = function () {
    var self = this;
    var names = this.p.options || [];
    this.opts.innerHTML = names.map(function (name, i) {
      var vals = self.values(i);
      if (vals.length <= 1) return '';
      var isColor = i === self.colorIdx;
      var btns = vals.map(function (val) {
        var ok = self.available(i, val);
        var on = self.sel[i] === val;
        var cls = (isColor ? 'c4-sw' : 'c4-opt') + (on ? ' is-on' : '') + (ok ? '' : ' is-out');
        var style = '';
        if (isColor) {
          var hex = (self.p.swatches || {})[val] || STORE_SWATCHES[val];
          var img = self.imageFor(val);
          style = hex ? ' style="--sw:' + esc(hex) + '"' : (img ? ' style="--sw-img:url(\'' + esc(img) + '\')"' : '');
        }
        return '<button type="button" class="' + cls + '"' + style + ' data-i="' + i + '" data-v="' + esc(val) +
          '" aria-pressed="' + on + '" aria-label="' + esc(name + ': ' + val + (ok ? '' : ' (esgotado)')) + '">' +
          (isColor ? '' : esc(val)) + '</button>';
      }).join('');
      // Nome da cor não fica fixo ao lado das bolinhas (confundia): aparece numa etiqueta ao
      // passar o mouse ou ao segurar a bolinha no celular (ver "etiqueta da cor").
      var label = '';
      // Nome do grupo (Tamanho, Gola…) em cima dos botões: separa um grupo do outro.
      var rowName = isColor ? '' : '<span class="c4-card__rowname">' + esc(name) + '</span>';
      return '<div class="c4-card__row' + (isColor ? ' c4-card__row--color' : '') + '" role="group" aria-label="' + esc(name) + '">' +
        rowName + btns + label + '</div>';
    }).join('');
    this.update();
  };
  Card.prototype.imageFor = function (color) {
    var ci = this.colorIdx;
    var v = this.p.variants.find(function (x) { return x.options[ci] === color && x.featured_image; });
    return v ? v.featured_image : '';
  };
  Card.prototype.update = function () {
    var v = this.variant();
    // preço: da variante escolhida, ou da 1ª variante da cor atual
    var ref = v || this.p.variants.find(function (x) {
      return this.colorIdx < 0 || x.options[this.colorIdx] === this.sel[this.colorIdx];
    }, this);
    if (ref && this.priceEl) {
      // Mesmo bloco do card da home (snippets/price.liquid): cheio riscado, Pix em destaque, parcelas.
      var cmp = ref.compare_at_price > ref.price ? '<s class="c4-price__cmp">' + brl(ref.compare_at_price) + '</s>' : '';
      var pix = Math.round(ref.price * (100 - PIX) / 100);
      var inst = PARCELAS > 1 ? '<span class="c4-price__inst">ou ' + PARCELAS + 'x de ' + brl(Math.floor(ref.price / PARCELAS)) + ' sem juros</span>' : '';
      this.priceEl.innerHTML = cmp + '<span class="c4-price__pix"><b>' + brl(pix) + '</b> no pix</span>' + inst;
    }
    this.msg.textContent = '';
    this.btn.classList.remove('is-added');
    // Esgotado: a variante escolhida, ou a cor inteira (ou o produto inteiro) sem estoque.
    var ci = this.colorIdx, cor = this.sel[ci];
    var temNaCor = this.p.variants.some(function (x) { return x.available && (ci < 0 || cor == null || x.options[ci] === cor); });
    if ((v && !v.available) || !temNaCor) {
      this.btn.disabled = true;
      this.btn.textContent = 'Esgotado';
    } else {
      this.btn.disabled = false;
      this.btn.textContent = this.btnLabel;
    }
  };
  Card.prototype.pick = function (i, val) {
    this.sel[i] = val;
    if (i === this.colorIdx) {
      // ao trocar de cor, solta o tamanho se ele não existe na cor nova
      var self = this;
      this.sel.forEach(function (s, j) {
        if (j !== i && s != null && !self.available(j, s)) self.sel[j] = j === self.sizeIdx ? null : self.values(j).find(function (x) { return self.available(j, x); }) || s;
      });
      var img = this.imageFor(val);
      if (this.firstImg && img) {
        this.firstImg.removeAttribute('srcset');
        this.firstImg.src = img;
        this.gallery.scrollTo({ left: 0 });
        syncDots(this.gallery);
      }
    }
    this.render();
  };
  // O carimbo do page-discount-cart-sync põe `:lv` em tudo que entra por esta página. Peça fora
  // do snapshot da campanha (o Estúdio não a listou) não ganha a campanha e, marcada como
  // exclusiva, ficaria também sem faixa: volta a ser peça comum da coleção.
  function fixLvStamp(v, data) {
    var pids = (root.querySelector('[data-c4-pg]') || root).getAttribute('data-pids') || '';
    var it = data && data.items && data.items[0];
    var pt = it && it.properties && it.properties._page_template;
    if (!pids || !v.pid || pids.indexOf(',' + v.pid + ',') >= 0 || !/:lv$/.test(String(pt || ''))) return data;
    var props = Object.assign({}, it.properties, { _page_template: String(pt).replace(/:lv$/, '') });
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).catch(function () { return data; });
  }

  Card.prototype.add = function () {
    var self = this;
    var missing = (this.p.options || []).filter(function (n, i) { return self.sel[i] == null; });
    if (missing.length) {
      this.msg.textContent = 'Escolha o ' + missing[0].toLowerCase();
      this.el.classList.add('c4-card--shake');
      setTimeout(function () { self.el.classList.remove('c4-card--shake'); }, 400);
      return;
    }
    var v = this.variant();
    if (!v || !v.available) return;
    this.btn.disabled = true;
    this.btn.textContent = 'Adicionando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) { return fixLvStamp(v, data); })
      .then(function (data) {
        updateCartUI(data && data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated'));
        self.btn.disabled = false;
        self.btn.classList.add('is-added');
        self.btn.textContent = '✓ Adicionado';
        // Sem aviso flutuante: a barra de progresso (sempre visível, grudada no menu) enche o
        // traço, e o botão mostra "✓ Adicionado". O aviso cobria a barra.
        if (!pg) showToast(self.p.title);
        setTimeout(function () { self.update(); }, 1800);
        if (self.el.classList.contains('c4-card--modal')) setTimeout(function () { closeModal(); }, 900);
      })
      .catch(function (err) {
        self.btn.disabled = false;
        self.btn.textContent = self.btnLabel;
        self.msg.textContent = (err && err.description) || 'Não foi possível adicionar. Tente de novo.';
      });
  };

  // Cor sem swatch cadastrado no próprio produto (ex.: Cuecas Minimal, Jeans 1.0) usa a
  // cor de mesmo nome cadastrada em outro produto da página, em vez de cair na foto.
  var STORE_SWATCHES = {};
  [].forEach.call(root.querySelectorAll('[data-c4-product]'), function (el) {
    try {
      var sw = JSON.parse(el.textContent).swatches || {};
      Object.keys(sw).forEach(function (k) { if (sw[k] && !STORE_SWATCHES[k]) STORE_SWATCHES[k] = sw[k]; });
    } catch (e) { /* ignora card inválido */ }
  });

  var cards = new Map();
  [].forEach.call(root.querySelectorAll('.c4-card'), function (el) {
    try { cards.set(el, new Card(el)); } catch (e) { /* card sem JSON válido: fica só o link pra PDP */ }
  });

  root.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-c4-nav]');
    if (nav) {
      var gal = nav.parentNode.querySelector('[data-c4-gallery]');
      gal.scrollBy({ left: gal.clientWidth * parseInt(nav.getAttribute('data-c4-nav'), 10), behavior: 'smooth' });
      return;
    }
    var cardEl = e.target.closest('.c4-card');
    var card = cardEl && cards.get(cardEl);
    if (!card) return;
    // Foto e nome: abre o popup (na grade) ou não faz nada (já no popup). O link para a
    // página do produto fica só no "Ver detalhes" do popup.
    if (e.target.closest('.c4-card__gallery, .c4-card__title a')) {
      e.preventDefault();
      if (!cardEl.classList.contains('c4-card--modal')) openModal(cardEl);
      return;
    }
    var opt = e.target.closest('[data-i]');
    if (opt && card.opts.contains(opt)) {
      if (opt.classList.contains('is-out') && parseInt(opt.getAttribute('data-i'), 10) !== card.colorIdx) return;
      card.pick(parseInt(opt.getAttribute('data-i'), 10), opt.getAttribute('data-v'));
      return;
    }
    if (e.target.closest('[data-c4-card-add]')) card.add();
  });

  /* ---------- card já no carrinho: check pequeno no canto + contorno claro ---------- */
  // Só peça que entrou por esta página (carimbo da coleção) marca o card — a mesma que conta
  // na barra. Card sem nenhuma variante no carrinho volta ao normal (tirou pelo carrinho).
  var STAMP = (root.querySelector('[data-c4-pg]') || root).getAttribute('data-stamp');
  function markInCart(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (it) {
      var pt = String((it.properties && it.properties._page_template) || '').replace(/:lv$/, '');
      if (!STAMP || pt === STAMP) inCart[it.variant_id] = true;
    });
    cards.forEach(function (card, el) {
      if (el.classList.contains('c4-card--modal')) return;
      el.classList.toggle('is-in-cart', card.p.variants.some(function (v) { return inCart[v.id]; }));
    });
  }

  /* ---------- etiqueta da cor: mouse em cima (desktop) ou segurar a bolinha (celular) ---------- */
  var tip = document.createElement('div');
  tip.className = 'c4-tip';
  tip.setAttribute('aria-hidden', 'true');
  document.body.appendChild(tip);
  var tipHide;
  function showTip(sw) {
    clearTimeout(tipHide);
    var txt = sw.getAttribute('data-v') + (sw.classList.contains('is-out') ? ' · esgotada' : '');
    tip.textContent = txt;
    var r = sw.getBoundingClientRect();
    tip.classList.add('is-on');
    var w = tip.offsetWidth;
    var vw = document.documentElement.clientWidth;
    var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), vw - w - 8);
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(r.top - tip.offsetHeight - 8) + 'px';
    tip.style.setProperty('--c4-tip-x', Math.round(r.left + r.width / 2 - left) + 'px');
  }
  function hideTip(delay) {
    clearTimeout(tipHide);
    tipHide = setTimeout(function () { tip.classList.remove('is-on'); }, delay || 0);
  }
  // Toque no celular também dispara mouseover (compatibilidade): sem esta trava a etiqueta
  // apareceria em qualquer toque, não só ao segurar.
  var lastTouch = 0;
  document.addEventListener('mouseover', function (e) {
    if (Date.now() - lastTouch < 1000) return;
    var sw = e.target.closest && e.target.closest('.c4-sw');
    if (sw && root.contains(sw)) showTip(sw);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.c4-sw');
    if (sw && !sw.contains(e.relatedTarget)) hideTip();
  });
  var pressTimer, pressed = null, longPressed = false;
  root.addEventListener('touchstart', function (e) {
    lastTouch = Date.now();
    var sw = e.target.closest('.c4-sw');
    if (!sw) return;
    longPressed = false;
    pressed = sw;
    clearTimeout(pressTimer);
    pressTimer = setTimeout(function () { longPressed = true; showTip(sw); }, 420);
  }, { passive: true });
  var endPress = function () {
    lastTouch = Date.now();
    clearTimeout(pressTimer);
    if (longPressed) hideTip(900);
    pressed = null;
  };
  root.addEventListener('touchend', endPress, { passive: true });
  root.addEventListener('touchcancel', endPress, { passive: true });
  root.addEventListener('touchmove', function () { clearTimeout(pressTimer); }, { passive: true });
  // Segurar para ver o nome não troca a cor: o clique que vem depois do toque longo é ignorado.
  root.addEventListener('click', function (e) {
    if (longPressed && e.target.closest('.c4-sw')) { e.preventDefault(); e.stopImmediatePropagation(); longPressed = false; }
  }, true);
  window.addEventListener('scroll', function () { if (tip.classList.contains('is-on')) hideTip(); }, { passive: true });

  /* ---------- guia de medidas (Sizebay) no popup ---------- */
  // Mesmo "Ficou com dúvidas sobre o seu tamanho?" da PDP (snippets/mc-size-help.liquid), mas
  // sem o script de implantação da Sizebay: ele só inicia UMA vez por página e aqui o produto
  // muda a cada popup. Usamos as mesmas chamadas que ele faz — sessão, id do produto na Sizebay
  // pelo id da Shopify, e a tabela dela num iframe. Produto sem medidas na Sizebay → o bloco
  // não aparece (igual à PDP).
  var SZB = 'https://vfr-v3-production.sizebay.technology';
  var szbSid = null, szbIds = {};
  function szbSession() {
    if (!szbSid) szbSid = fetch(SZB + '/api/me/session-id').then(function (r) { return r.text(); }).then(function (t) { return t.replace(/"/g, '').trim(); });
    return szbSid;
  }
  function szbProductId(pid) {
    if (!szbIds[pid]) {
      szbIds[pid] = szbSession().then(function (sid) {
        return fetch(SZB + '/plugin/my-product-id?sid=' + encodeURIComponent(sid) + '&permalink=' + encodeURIComponent('https://minimalclub.com.br/' + pid))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { return d && d.id && !d.accessory ? { id: d.id, sid: sid } : null; });
      }).catch(function () { return null; });
    }
    return szbIds[pid];
  }
  // mode 'vfr' = Provador Virtual; 'chart' = Tabela de Medidas. Mesmas URLs que o script da
  // Sizebay abre na PDP.
  function sizebayUrl(mode, info, sizes) {
    var enc = '';
    try { enc = btoa(unescape(encodeURIComponent(JSON.stringify(sizes)))); } catch (e) { /* sem tamanhos */ }
    var q = 'id=' + encodeURIComponent(info.id) + '&sid=' + encodeURIComponent(info.sid) + '&lang=br&tenantId=1269&sizes=' + enc;
    if (mode === 'vfr') {
      return SZB + '/V4/?mode=vfr&' + q + '&backdropWidth=' + window.innerWidth + '&backdropHeight=' + window.innerHeight + '&isMeasurementsTableEnabled=true';
    }
    return 'https://measurements-table.sizebay.technology/?' + q + '&pageProductImg=false&hasRecommendation=&device=false';
  }
  function openSizeTable(info, sizes, mode) {
    var url = sizebayUrl(mode, info, sizes);
    var ov = document.createElement('div');
    // O provador precisa da tela inteira (é assim na PDP); caixa menor ele trata como tablet em pé.
    ov.className = 'c4-szb' + (mode === 'vfr' ? ' c4-szb--full' : '');
    // A tabela tem o próprio X: ela avisa a página com postMessage "close-fitting-room".
    ov.innerHTML = '<div class="c4-szb__box"><iframe class="c4-szb__frame" title="Tabela de medidas" src="' + esc(url) + '"></iframe></div>';
    var close = function () {
      ov.remove();
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('message', onMsg);
    };
    var onKey = function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } };
    var onMsg = function (e) {
      if (/sizebay\.technology$/.test(e.origin) && String(e.data).indexOf('close') >= 0) close();
    };
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('message', onMsg);
    document.body.appendChild(ov);
  }
  function addSizeHelp(clone, card) {
    var btn = clone.querySelector('.c4-card__add');
    if (!btn) return;
    var box = document.createElement('div');
    box.className = 'c4-szh';
    box.hidden = true;
    box.innerHTML = '<p class="c4-szh__q"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.7 2.2c-.8.5-1.2 1-1.2 2"/><circle cx="12" cy="16.5" r=".6" fill="#121212" stroke="none"/></svg>Ficou com dúvidas sobre o seu tamanho?</p>' +
      '<button type="button" class="c4-szh__btn" aria-expanded="false"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="8" width="18" height="8" rx="1"/><path d="M7 8v3M11 8v2M15 8v3M19 8v2"/></svg>Guia de medidas</button>' +
      '<div class="c4-szh__panel" hidden>' +
        '<button type="button" class="c4-szh__row" data-szb="vfr"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="7" r="3"/><path d="M6 21v-2a6 6 0 0 1 12 0v2"/></svg><span><strong>Provador Virtual</strong><small>Insira informações básicas para simulação</small></span></button>' +
        '<button type="button" class="c4-szh__row c4-szh__row--accent" data-szb="chart"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M8 4 4 7l2 3 2-1v11h8V9l2 1 2-3-4-3-2 2h-2z"/></svg><span><strong>Tabela de Medidas</strong><small>Veja a tabela completa por tamanho</small></span></button>' +
      '</div>';
    btn.parentNode.insertBefore(box, btn);
    // Produto da cor escolhida (cores irmãs são outros produtos) — cai no 1º se não houver.
    var pidNow = function () {
      var ci = card.colorIdx, cor = card.sel[ci];
      var v = card.p.variants.find(function (x) { return x.pid && (ci < 0 || x.options[ci] === cor); }) || card.p.variants[0];
      return v && v.pid;
    };
    var pid = pidNow();
    if (!pid) return;
    szbProductId(pid).then(function (info) { if (info && box.isConnected) box.hidden = false; });
    // Igual à PDP: "Guia de medidas" abre as duas opções; cada uma abre a tela da Sizebay.
    var trigger = box.querySelector('.c4-szh__btn');
    var panel = box.querySelector('.c4-szh__panel');
    trigger.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
    });
    panel.addEventListener('click', function (e) {
      var row = e.target.closest('[data-szb]');
      if (!row) return;
      var sizes = card.sizeIdx >= 0 ? card.values(card.sizeIdx) : [];
      szbProductId(pidNow() || pid).then(function (info) {
        return info || szbProductId(pid);
      }).then(function (info) { if (info) openSizeTable(info, sizes, row.getAttribute('data-szb')); });
    });
  }

  /* ---------- popup do produto (em vez de ir pra página dele) ---------- */
  // Foto e nome abrem o MESMO card num popup maior: cópia do card com a seleção atual, com
  // instância própria de Card — adicionar por ele é o mesmo fluxo do card da grade.
  var modal = document.createElement('div');
  modal.className = 'c4-modal';
  modal.hidden = true;
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.innerHTML = '<div class="c4-modal__box" tabindex="-1"><button type="button" class="c4-modal__close" data-c4-modal-close aria-label="Fechar">&times;</button><div class="c4-modal__body"></div></div>';
  root.appendChild(modal);
  var modalBody = modal.querySelector('.c4-modal__body');
  var modalCard = null;
  var modalOpener = null;
  function openModal(cardEl) {
    var orig = cards.get(cardEl);
    if (!orig) return;
    closeModal(true);
    var clone = cardEl.cloneNode(true);
    clone.classList.add('c4-card--modal');
    [].forEach.call(clone.querySelectorAll('img[loading="lazy"]'), function (img) { img.removeAttribute('loading'); });
    var info = clone.querySelector('.c4-card__info');
    var link = clone.querySelector('.c4-card__title a');
    if (info && link) {
      var more = document.createElement('a');
      more.className = 'c4-modal__more';
      more.href = link.href;
      more.textContent = 'Ver detalhes do produto';
      info.appendChild(more);
    }
    modalBody.appendChild(clone);
    var mc = new Card(clone);
    mc.sel = orig.sel.slice();
    mc.render();
    mc.origEl = cardEl;
    cards.set(clone, mc);
    addSizeHelp(clone, mc);
    modalCard = clone;
    var gal = clone.querySelector('[data-c4-gallery]');
    if (gal) {
      gal.scrollLeft = 0;
      // Desktop: miniaturas numa coluna ao lado da foto (no celular ficam escondidas por CSS e
      // vale o deslizar + bolinhas, como no card).
      var media = clone.querySelector('.c4-card__media');
      var wrap = document.createElement('div');
      wrap.className = 'c4-modal__gal';
      var thumbs = document.createElement('div');
      thumbs.className = 'c4-modal__thumbs';
      var imgs = [].slice.call(gal.querySelectorAll('img'));
      imgs.forEach(function (img, i) {
        var bt = document.createElement('button');
        bt.type = 'button';
        bt.className = 'c4-modal__thumb' + (i === 0 ? ' is-on' : '');
        bt.setAttribute('aria-label', 'Foto ' + (i + 1));
        bt.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="">';
        bt.addEventListener('click', function () { gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' }); });
        thumbs.appendChild(bt);
      });
      media.parentNode.insertBefore(wrap, media);
      wrap.appendChild(thumbs);
      wrap.appendChild(media);
      // Trocar a cor troca a 1ª foto (Card.pick): a 1ª miniatura acompanha.
      if (imgs[0]) {
        new MutationObserver(function () {
          var t0 = thumbs.querySelector('img');
          if (t0) t0.src = imgs[0].currentSrc || imgs[0].src;
        }).observe(imgs[0], { attributes: true, attributeFilter: ['src'] });
      }
      var t;
      gal.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          syncDots(gal);
          var at = Math.round(gal.scrollLeft / Math.max(gal.clientWidth, 1));
          [].forEach.call(thumbs.children, function (bt, j) { bt.classList.toggle('is-on', j === at); });
        }, 60);
      }, { passive: true });
    }
    modalOpener = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('c4-modal-open');
    requestAnimationFrame(function () { modal.classList.add('is-on'); });
    // Foco no quadro (não no X): o foco no botão desenhava o anel de foco do tema no Safari.
    modal.querySelector('.c4-modal__box').focus({ preventScroll: true });
  }
  function closeModal(instant) {
    if (modal.hidden) return;
    modal.classList.remove('is-on');
    document.documentElement.classList.remove('c4-modal-open');
    var done = function () {
      modal.hidden = true;
      if (modalCard) { cards.delete(modalCard); modalCard = null; }
      modalBody.innerHTML = '';
    };
    if (instant) done(); else setTimeout(done, 250);
    if (modalOpener && modalOpener.focus) modalOpener.focus();
  }
  modal.addEventListener('click', function (e) {
    if (e.target === modal || e.target.closest('[data-c4-modal-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ---------- faixa corrida por cima da faixa do frete grátis ---------- */
  // A faixa do frete (.announcement-bar-section) é fixa no topo em todas as páginas. Aqui a
  // faixa corrida entra por cima dela, da esquerda pra direita, e fica. Sem a faixa do frete
  // na tela (escondida no admin), a corrida fica no topo da própria página.
  var mq = root.querySelector('[data-c4-mq]');
  if (mq) {
    var ann = document.querySelector('.announcement-bar-section');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (ann && ann.offsetHeight > 0 && getComputedStyle(ann).display !== 'none') {
      if (getComputedStyle(ann).position === 'static') ann.style.position = 'relative';
      ann.appendChild(mq);
      mq.classList.add('c4-mq--over');
      setTimeout(function () { mq.classList.add('is-in'); }, reduce ? 0 : 800);
    } else {
      root.insertBefore(mq, root.firstChild);
      mq.classList.add('is-in');
    }
  }

  /* ---------- barra de progresso: a cada N peças, N − M grátis ---------- */
  var pg = root.querySelector('[data-c4-pg]');
  var pgSlot = root.querySelector('[data-c4-pg-slot]');
  if (pg && pgSlot) {
    var PG_N = parseInt(pg.getAttribute('data-n'), 10) || 4;
    var PG_FREE = PG_N - (parseInt(pg.getAttribute('data-m'), 10) || PG_N - 1);
    var PG_STAMP = pg.getAttribute('data-stamp');
    var PG_PIDS = pg.getAttribute('data-pids') || '';

    pg.innerHTML = '<div class="c4-pg__in"><span class="c4-pg__msg"></span><div class="c4-pg__bars"></div><span class="c4-pg__chip"></span></div>';
    var pgMsg = pg.querySelector('.c4-pg__msg');
    var pgBars = pg.querySelector('.c4-pg__bars');
    var pgChip = pg.querySelector('.c4-pg__chip');
    var PG_MAX_MINI = 4; // conjuntos completos visíveis como mini traços; o selo mostra o total
    var pgFirst = true;
    var makeSet = function () {
      var el = document.createElement('span');
      el.className = 'c4-pg__set';
      var html = '';
      for (var i = 1; i <= PG_N; i++) {
        html += '<span class="c4-pg__seg' + (i > PG_N - PG_FREE ? ' is-gift' : '') + '">' +
          (i === PG_N ? '<span class="c4-pg__tag">GRÁTIS</span>' : '') + '</span>';
      }
      el.innerHTML = html;
      return el;
    };
    var growIn = function (el) {
      el.classList.add('is-new');
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-new'); }); });
    };
    var renderPg = function (units) {
      var sets = Math.floor(units / PG_N);
      var rest = units % PG_N;
      var falta = PG_N - rest;
      var free = sets * PG_FREE;
      var um = PG_FREE === 1;
      var msg;
      if (units === 0) msg = 'Escolha <b>' + PG_N + ' peças</b> e ' + (um ? 'a <span class="c4-pg__o">' + PG_N + 'ª sai grátis</span>' : 'ganhe <span class="c4-pg__o">' + PG_FREE + ' grátis</span>');
      else if (sets === 0) msg = 'Faltam <b>' + falta + ' ' + (falta === 1 ? 'peça' : 'peças') + '</b> para ganhar ' + PG_FREE + ' grátis';
      else if (rest === 0) msg = '<span class="c4-pg__o">' + free + ' ' + (free === 1 ? 'peça grátis' : 'peças grátis') + '</span> · +' + PG_N + ' ganha outra';
      else msg = 'Faltam <b>' + falta + '</b> para ganhar mais ' + PG_FREE + ' grátis';
      pgMsg.innerHTML = msg;
      pgChip.className = 'c4-pg__chip' + (sets ? ' c4-pg__chip--on' : '');
      pgChip.innerHTML = sets ? '<b>✓</b> ' + free + ' grátis' : rest + '/' + PG_N;

      // Ao completar um conjunto ele já encolhe para mini traços e o próximo entra vazio,
      // ocupando a largura: mostra que dá pra ganhar mais uma.
      var total = sets + 1;
      var big = sets;
      while (pgBars.children.length > total) pgBars.removeChild(pgBars.lastChild);
      while (pgBars.children.length < total) {
        var el = makeSet();
        pgBars.appendChild(el);
        if (!pgFirst) growIn(el);
      }
      // Mini traços: maiores com um conjunto ganho, diminuindo conforme entram mais.
      var minis = Math.min(big, PG_MAX_MINI);
      var wide = window.matchMedia('(min-width: 750px)').matches;
      var miniW = (wide ? [72, 60, 50, 42] : [52, 44, 36, 30])[Math.max(0, minis - 1)];
      pgBars.style.setProperty('--c4-mini', miniW + 'px');
      // Primeira pintura (carrinho que já tinha peças) aparece pronta, sem animar.
      if (pgFirst) pg.classList.add('c4-pg--instant');
      var novo = 0;
      [].forEach.call(pgBars.children, function (el, i) {
        el.classList.toggle('is-mini', i < big);
        el.classList.toggle('is-hidden', i < big - PG_MAX_MINI);
        var filled = i < big ? PG_N : rest;
        [].forEach.call(el.children, function (seg, j) {
          var on = j < filled;
          // Várias peças de uma vez enchem uma depois da outra.
          if (on && !seg.classList.contains('is-on')) seg.style.transitionDelay = (novo++ * 0.15) + 's';
          else seg.style.transitionDelay = '';
          seg.classList.toggle('is-on', on);
        });
      });
      if (pgFirst) {
        void pg.offsetHeight;
        requestAnimationFrame(function () { pg.classList.remove('c4-pg--instant'); });
      }
      pgFirst = false;
    };
    var countUnits = function (cart) {
      return (cart.items || []).reduce(function (n, it) {
        var pt = String((it.properties && it.properties._page_template) || '').replace(/:lv$/, '');
        if (pt !== PG_STAMP) return n;
        if (PG_PIDS && PG_PIDS.indexOf(',' + it.product_id + ',') < 0) return n;
        return n + (it.quantity || 0);
      }, 0);
    };
    var refreshPg = function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderPg(countUnits(cart)); markInCart(cart); })
        .catch(function () { /* fica a última contagem */ });
    };
    renderPg(parseInt(pg.getAttribute('data-units'), 10) || 0);
    if (pg.getAttribute('data-units') !== '0') refreshPg(); // marca os cards que já estão no carrinho
    document.addEventListener('cart:updated', refreshPg);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshPg);
    }

    // Gruda logo abaixo do menu ao rolar. O menu do tema é position:fixed (announcement-bar.js)
    // e o body tem overflow:hidden, então position:sticky não funciona: a barra vira fixed
    // quando passa do menu, e o slot guarda a altura dela pra página não pular.
    var header = document.querySelector('.section-header');
    var stickPg = function () {
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var stuck = pgSlot.getBoundingClientRect().top < top;
      if (stuck) {
        pgSlot.style.height = pg.offsetHeight + 'px';
        pg.style.top = top + 'px';
      }
      if (stuck !== pg.classList.contains('is-stuck')) {
        pg.classList.toggle('is-stuck', stuck);
        if (!stuck) { pgSlot.style.height = ''; pg.style.top = ''; }
      }
    };
    window.addEventListener('scroll', stickPg, { passive: true });
    window.addEventListener('resize', stickPg);
    stickPg();
  }

  /* ---------- toast ---------- */
  var toast = document.createElement('div');
  toast.className = 'c4-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  document.body.appendChild(toast);
  var toastTimer;
  // Posiciona o aviso logo abaixo do ícone do carrinho, com a setinha apontando pra ele.
  // Sem o ícone na tela (cabeçalho rolou pra fora), fica no topo à direita.
  function placeToast() {
    var icon = document.getElementById('cart-icon-bubble');
    var r = icon && icon.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    if (r && r.bottom > 0 && r.top < window.innerHeight) {
      var right = Math.max(12, vw - r.right - 6);
      toast.style.top = Math.round(r.bottom + 10) + 'px';
      toast.style.right = right + 'px';
      var arrow = Math.max(10, Math.round(vw - right - (r.left + r.width / 2) - 5));
      toast.style.setProperty('--c4-arrow', arrow + 'px');
    } else {
      toast.style.top = '12px';
      toast.style.right = '12px';
      toast.style.setProperty('--c4-arrow', '18px');
    }
  }
  function showToast(name) {
    toast.innerHTML = '<span class="c4-toast__txt">✓ <b>' + esc(name) + '</b> no carrinho</span>' +
      '<button type="button" class="c4-toast__cta">Ver carrinho</button>';
    placeToast();
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }
  window.addEventListener('scroll', function () { if (toast.classList.contains('is-on')) placeToast(); }, { passive: true });
  window.addEventListener('resize', function () { if (toast.classList.contains('is-on')) placeToast(); });
  toast.addEventListener('click', function (e) {
    if (!e.target.closest('.c4-toast__cta')) return;
    toast.classList.remove('is-on');
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = '/cart';
  });

  // Mesma estratégia do dp-quick-buy.js: re-render completo do #CartDrawer sem abri-lo.
  function updateCartUI(sections) {
    if (!sections) return;
    try {
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var src = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && src) bubble.innerHTML = src.innerHTML;
      }
      if (sections['cart-drawer']) {
        var drawer = document.querySelector('cart-drawer');
        var current = document.getElementById('CartDrawer');
        var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (current && fresh) {
          current.innerHTML = fresh.innerHTML;
          var overlay = current.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer && typeof drawer.close === 'function') {
            overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        if (drawer) drawer.classList.remove('is-empty');
      }
    } catch (e) { /* o add já foi feito */ }
  }
})();
